import { store } from '@redux/store';
import fastdom from 'fastdom';
import { onArticleCountResultsLoaded$, selectSearchTerm } from 'features/articleSearchResultsFacets';

// function to display the html response of blog articles
const updateHeadingTitle = function(countResults) {
    const headingTitleElement = document.querySelector('[data-component="blog-article-search-results-title"]');
    
    if(headingTitleElement){
        const searchTerm = selectSearchTerm(store.getState());
        fastdom.mutate(() => {
            // when the search term is used we change the title to 'Results for “searchTerm” (number of results)'
            if(searchTerm){
                headingTitleElement.innerHTML = `Results For “${searchTerm}” (${countResults})`;
            }
            else{

                // Alternative text from the source always contains the number of results like: 'Value set (90)'
                const currentHeadingTitle = headingTitleElement.textContent;
                const updatedTitle = currentHeadingTitle.replace(/\(\d+\)/, `(${countResults})`);
                headingTitleElement.textContent = updatedTitle;
            }
        });
    } 
};
    
onArticleCountResultsLoaded$.subscribe(updateHeadingTitle);